import(/* webpackMode: "eager" */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/global-error.tsx");
